import React from 'react';

const FilterInput = ({ placeholder, value, onChange }) => {
  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="filter-input"
    />
  );
};

export default FilterInput;
